import './App.css';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import {
  useFirebaseApp,
  FirestoreProvider,
  StorageProvider,
  AuthProvider,
  FunctionsProvider,
  AnalyticsProvider,
} from 'reactfire';
import { NextUIProvider } from '@nextui-org/react';
import RootLayout from './layout/layout';
import Landing from './pages/Landing';
import { Extractor } from './pages/extractor/extractor';
import { pdfjs } from 'react-pdf';
import Generators from './pages/generators/generators';
import { Generator } from './pages/generators/generator';
import { JobManger } from './pages/jobs/jobManger';
import Comparators from './pages/comparators/comparators';
import { Comparator } from './pages/comparators/comparator';
import { Signup } from './pages/auth/signup';
import Extractors from './pages/extractor/extractors';
import PrivateRoute from './layout/privateRoute';
import { Login } from './pages/auth/login';
import { UserUsage } from './pages/user/userUsage';
import { Settings } from './pages/user/settings';
import { initializeApp } from 'firebase/app';
import { firebaseConfig } from './firebase-config';
import KnowledgeBases from './pages/kbase/kbases';
import { KnowledgeBase } from './pages/kbase/kbase';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function App() {
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  const firestoreInstance = getFirestore(app);
  const storageInstance = getStorage(app);
  const authInstance = getAuth(app);
  const functionsInstance = getFunctions(app, 'us-west1');
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // Set up emulators
    connectStorageEmulator(storageInstance, '127.0.0.1', 9100);
    connectAuthEmulator(authInstance, 'http://localhost:9099', {
      disableWarnings: false,
    });
    connectFirestoreEmulator(firestoreInstance, '127.0.0.1', 8081);
    connectFunctionsEmulator(functionsInstance, '127.0.0.1', 5001);
  }
  return (
    <NextUIProvider>
      <AnalyticsProvider sdk={analytics}>
        <FirestoreProvider sdk={firestoreInstance}>
          <StorageProvider sdk={storageInstance}>
            <AuthProvider sdk={authInstance}>
              <FunctionsProvider sdk={functionsInstance}>
                <Routes>
                  <Route path="/" element={<RootLayout />}>
                    <Route index element={<Landing />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/login" element={<Login />} />

                    <Route path="/extractors" element={<PrivateRoute><Extractors /></PrivateRoute>} />
                    <Route path="/extractor/:id" element={<PrivateRoute><Extractor /></PrivateRoute>} />
                    <Route path="/generators" element={<PrivateRoute><Generators /></PrivateRoute>} />
                    <Route path="/generators/:id" element={<PrivateRoute><Generator /></PrivateRoute>} />
                    <Route path="/kbases" element={<PrivateRoute><KnowledgeBases /></PrivateRoute>} />
                    <Route path="/kbases/:id" element={<PrivateRoute><KnowledgeBase /></PrivateRoute>} />
                    <Route path="/comparators" element={<PrivateRoute><Comparators /></PrivateRoute>} />
                    <Route path="/comparators/:id" element={<PrivateRoute><Comparator /></PrivateRoute>} />
                    <Route path="/jobmanager/" element={<PrivateRoute><JobManger /></PrivateRoute>} />
                    <Route path="/user/" element={<PrivateRoute><UserUsage /></PrivateRoute>} />
                    <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
                    <Route path="*" element={<Landing />} />
                  </Route>
                </Routes>
              </FunctionsProvider>
            </AuthProvider>
          </StorageProvider>
        </FirestoreProvider>
      </AnalyticsProvider>
    </NextUIProvider>
  );
}

export default App;
